<template>
  <el-drawer
    :visible.sync="show"
    :append-to-body="true"
    :close-on-press-escape="true"
    direction="ltr"
    :show-close="true"
    :size="drawerSize + '%'"
    :modal="false"
  >
    <div class="drawer-wrapper py-10 px-3 flex flex-col h-full">

      <div class="drawer-header">
        <ul class="nav">

          <router-link to="/dashboard" class="nav-item" active-class="active" v-if="hasMenuAction('INITIAL_MONITORING')">
            <div class="nav-link" @click="handleCloseDrawer">
              <i class="fa-solid fa-table-cells-large nav-link-icon"/>
              <span>{{$t('sidebar.dashboard')}}</span>
            </div>
          </router-link>

          <router-link to="/pledge-monitoring" class="nav-item" active-class="active" v-if="hasMenuAction('PLEDGE_MONITORING')">
            <div class="nav-link" @click="handleCloseDrawer">
              <i class="fa-solid fa-chart-column nav-link-icon"/>
              <span>Жорий мониторинги</span>
            </div>
          </router-link>

          <router-link to="/initial-monitoring" class="nav-item" active-class="active" v-if="hasMenuAction('TARGETED_INSPECTION_MONITORING')">
            <div class="nav-link" @click="handleCloseDrawer">
              <i class="fa-solid fa-chart-column nav-link-icon"/>
              <span>Дастлабки мониторинги</span>
            </div>
          </router-link>

        </ul>
      </div>

      <div class="drawer-body flex-auto language">
        <el-collapse>
          <el-collapse-item :title="$t('headerPanel.language')" name="language">
            <div class="language-item" :class="{'active': language === 'uz'}" @click="changeLanguage('uz')">Ўзбекча</div>
            <div class="language-item" :class="{'active': language === 'ru'}" @click="changeLanguage('ru')">Русский</div>
          </el-collapse-item>
        </el-collapse>
      </div>

    </div>
  </el-drawer>
</template>

<script>
export default {
  name: "Drawer",
  props: {
    toggleDrawer: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      drawerSize: 40,
      languageItems: null
    }
  },
  computed: {
    show: {
      get: function () {
        return this.toggleDrawer
      },
      set: function(newVal) {
        this.$emit("toggle")
      }
    },
    language() {
      return this.$i18n.locale;
    }
  },
  methods: {
    setDrawerSize() {
        this.drawerSize = window.innerWidth > 475 ?
          window.innerWidth < 640 ?
            70
            : window.innerWidth > 1280 ?
              this.$emit("toggle") : 45 : 100;
    },
    changeLanguage(langCode) {
      this.languageCode = langCode;
      this.$i18n.locale = langCode;
      localStorage.setItem('x_lang', langCode);
      document.querySelector('html').setAttribute('lang', langCode);
    },
    handleCloseDrawer() {
      this.$emit('update:toggle-drawer', false)
    }
  },
  mounted() {
    window.addEventListener('resize', this.setDrawerSize)
  },
  destroyed() {
    window.removeEventListener('resize', this.setDrawerSize)
  }
}
</script>

<style scoped>

</style>
